import { getItem, removeItem } from "./storage";

/*
  Reading the stored Device id, apart from registering one (device.ts), so the API
  client can name the Device on a token refresh without importing the module that
  itself calls the API client.
*/

export const deviceKey = "device_id";

interface StoredDevice {
  accountId: string;
  id: string;
}

export const readStoredDevice = (): StoredDevice | undefined => {
  try {
    const raw = getItem(deviceKey);
    const parsed = raw ? (JSON.parse(raw) as Partial<StoredDevice>) : undefined;
    return parsed?.accountId && parsed.id ? { accountId: parsed.accountId, id: parsed.id } : undefined;
  } catch {
    return undefined;
  }
};

/** This browser's Device for `accountId`, if it has registered one. */
export const storedDeviceId = (accountId?: string): string | undefined => {
  const stored = readStoredDevice();
  return stored && stored.accountId === accountId ? stored.id : undefined;
};

/** Drops the stored id, so the next `ensureDevice` registers afresh. */
export const forgetStoredDevice = () => removeItem(deviceKey);
